








import React from "react";
import { Link } from "react-router-dom";
import "../styles/PureCarTruckCarriers.css";

// Import your icon and image
import pctcIcon from "../assets/icons/pctc-icon.png";
import pctcImage from "../image/PureCarTruckCarriers-image.png";

const PureCarTruckCarriers = () => {
  return (
    <div className="pctc-container">
      {/* Image Slider */}
      <div className="pctc-image-slider">
        <img src={pctcImage} alt="Pure Car Truck Carriers Slider" />
      </div>



      {/* Main Content Container */}
      <div className="pctc-content">
        {/* Content Card with title inside */}
        <div className="pctc-card">
          {/* Ship wheel icon and title */}
          <div className="pctc-header-container">
            <img src={pctcIcon} alt="PCTC" className="pctc-wheel-icon" />
            <div className="pctc-header-title">Pure Car & Truck Carriers (PCTCs)</div>
          </div>
          
          {/* Content */}
          <div className="pctc-text-content">
            <p className="pctc-text">
              Automobiles that are transported by ship around the world are often moved on a large type of RORO called a Pure Car Carriers (PCCs) or Pure Car Truck Carriers (PCTCs).
            </p>
            
            <p className="pctc-text">
              Pure Car Carriers and their close cousins, the Pure Car Truck Carriers (PCTCs) are distinctive ships with a box-like superstructure running the entire length and breadth of the hull, fully enclosing and protecting the cargo.
            </p>
            
            <p className="pctc-text">
              ECL's PCTC vessels are designed with a large rampway at the stern and ship's side to load any vehicles that can run on their own power. It also is equipped with liftable decks and car lifters to handle High height vehicles upto 4.5 mtrs.
            </p>
            
            <p className="pctc-text">
              ECL's PCTC vessels which range from 3700 dwt upto 10900 dwt and with speed of upto 20 knots are built for safe and speedy transport of automobiles with a carrying capacity of unto 4500 units.
            </p>
          </div>
          
          {/* Right Side Panel */}
          <div className="pctc-side-panel">
            <Link to="/multi-purpose-vessels" className="pctc-panel-link">
              <div className="pctc-panel-section">
                <h4 className="pctc-panel-title">Multi-Purpose Vessels(MPV's) :</h4>
                <p className="pctc-panel-text">
                  ECL's Multi-purpose fleet largely comprise of small handy vessels in the range of 7000 dwt to 14000 dwt with predominantly two large holds and a tank top strength upto 13 tons per sq. mtr.
                </p>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PureCarTruckCarriers;